import { ComponentProps } from 'react';
import { Link } from 'react-router-dom';

import { useInstanceId } from '@frontend/hooks';

type LinkProps = ComponentProps<typeof Link>;

export function NamespacedLink(props: LinkProps) {
  const { instanceId } = useInstanceId();
  const { to, ...rest } = props;
  const namespacedTo =
    typeof to === 'string' && to.startsWith('/') ? `/instances/${instanceId}${to}` : to;

  return <Link to={namespacedTo} {...rest} />;
}
